import { Vue } from 'vue-class-component';
import { Media$Details, PLAYABLE_MEDIA_TYPES } from '@/types/Media';
import isSame from '@Ravnur-Inc/nanoutils/isSame';
import some from '@Ravnur-Inc/nanoutils/some';
import MediaEmbedCode from '../media-embed-code/media-embed-code';

import './media-embed.scss';

const CN = 'media-embed';

class Props {
  origin!: Media$Details;
}

export default class MediaEmbed extends Vue.with(Props) {
  get isPlayableMediaType() {
    return some(isSame(this.origin.type), PLAYABLE_MEDIA_TYPES);
  }

  render() {
    if (!this.origin.isEnabledEmbedding || !this.isPlayableMediaType) {
      return;
    }

    return (
      <div class={CN}>
        <MediaEmbedCode origin={this.origin} />
      </div>
    );
  }
}
